import { render, staticRenderFns } from "./ContactTypeForm.vue?vue&type=template&id=4fb156ba&"
import script from "./ContactTypeForm.vue?vue&type=script&lang=js&"
export * from "./ContactTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./ContactTypeForm.vue?vue&type=style&index=0&id=4fb156ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports